// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".143bdb81a007e734a1cf62f6482c4dac29303f31.chunk.js";
};